<template>
    <div class="model-preview-container" ref="previewContainer">
        <div class="model-preview wrapper" ref="preview">
            <span class="arrow" ref="arrow"></span>
            <div class="glide">
                <div class="model-preview-nav">
                    <a href="#" class="btn-close-preview" @click.prevent="doHidePreview()"></a>
                    <div class="glide__arrows" data-glide-el="controls">
                        <a href="#" class="btn-next-model glide__arrow glide__arrow--right" data-glide-dir=">"></a>
                        <a href="#" class="btn-prev-model glide__arrow glide__arrow--left" data-glide-dir="<"></a>
                    </div>
                </div>
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides">
                        <li class="glide__slide">
                            <preview-model :index="firstInRow"></preview-model>
                        </li>
                        <li class="glide__slide">
                            <preview-model :index="firstInRow+1"></preview-model>
                        </li>
                        <li class="glide__slide">
                            <preview-model :index="firstInRow+2"></preview-model>
                        </li>
                        <li class="glide__slide">
                            <preview-model :index="firstInRow+3"></preview-model>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import {TweenMax} from "gsap/all"
    import Glide from '@glidejs/glide'
    import PreviewModel from './PreviewModel'

    export default {
        components: {PreviewModel},
        props: ['index'],
        data: function () {
            return {
                previewOpened: false,
                currentRow: null,
                glide: null,
            }
        },
        mounted() {
            this.resetImages()
            this.arrowIndex = this.index
            this.glide = new Glide('.glide', {type: 'slider', animationDuration: 900}).mount()
            this.glide.on(['run'], function () {
                this.setArrow()
            }.bind(this))
        },
        watch: {
            index: function () {
                this.glide.go('=' + this.column + '')
                if (this.currentRow !== this.row) {
                    if (this.currentRow) {
                        this.hidePreview()
                    }
                    this.openAndSetRow()
                    this.currentRow = this.row;
                }
                this.setArrow();
            },
            forceHidePreview: function () {
                if (this.forceHidePreview) {
                    this.currentRow = null
                    this.hidePreview()
                }
            }
        },
        computed: {
            ...mapState(['forceHidePreview']),
            rowHeight() {
                return this.windowWidth > 1240 ? 440 : 360
            },
            previewHeight() {
                return this.windowWidth > 1240 ? 620 : 540
            },
            thumbWidth() {
                return this.windowWidth > 1240 ? 300 : 250
            },
            column() {
                return (this.index - 1) % 4
            },
            row() {
                return Math.ceil(this.index / 4)
            },
            firstInRow() {
                return this.index - this.column - 1
            },
            top() {
                return (this.row * this.rowHeight) + 10
            },
            arrowLeft() {
                return this.thumbWidth * this.glide.index + this.thumbWidth / 2
            },
            allThumbs() {
                return document.getElementsByClassName('model')
            },
            previewImages() {
                return document.querySelectorAll('.preview-image')
            },
            modelThumb1() {
                return document.getElementById('model' + this.firstInRow)
            },
            modelThumb2() {
                return document.getElementById('model' + (this.firstInRow + 1))
            },
            modelThumb3() {
                return document.getElementById('model' + (this.firstInRow + 2))
            },
            modelThumb4() {
                return document.getElementById('model' + (this.firstInRow + 3))
            },
        },
        methods: {
            setArrow() {
                TweenMax.to(this.$refs.arrow, 0.4, {left: this.arrowLeft})
            },
            openAndSetRow() {
                if (this.modelThumb1) {
                    TweenMax.to(this.modelThumb1, 0.4, {marginBottom: (this.previewHeight + 40)})
                }
                if (this.modelThumb2) {
                    TweenMax.to(this.modelThumb2, 0.4, {marginBottom: (this.previewHeight + 40)})
                }
                if (this.modelThumb3) {
                    TweenMax.to(this.modelThumb3, 0.4, {marginBottom: (this.previewHeight + 40)})
                }
                if (this.modelThumb4) {
                    TweenMax.to(this.modelThumb4, 0.4, {marginBottom: (this.previewHeight + 40)})
                }
                TweenMax.to(this.$refs.previewContainer, 0, {top: this.top})
                TweenMax.to(this.$refs.previewContainer, 0.4, {height: this.previewHeight, opacity: 1})
                setTimeout(function () {
                    this.$scrollTo(this.$refs.preview, 500, {offset: -170})
                    TweenMax.to(this.$refs.preview, 0.6, {height: this.previewHeight, opacity: 1})
                }.bind(this), 600)
            },
            doHidePreview(){
                this.$store.dispatch('forceHidePreview')
            },
            hidePreview() {
                this.resetImages()
                TweenMax.to(this.allThumbs, 0.4, {marginBottom: 9})
                TweenMax.to(this.$refs.previewContainer, 0, {opacity: 0,top: -1500})
                TweenMax.to(this.$refs.preview, 0, {opacity: 0})
                TweenMax.to(this.$refs.previewContainer, 0, {height: 0})
            },
            resetImages() {
                _.forEach(this.previewImages, function (el) {
                    if (el.classList.contains('justloaded')) {
                        el.classList.remove('visible')
                    }
                    el.classList.remove('justloaded')
                }.bind(this))
            }

        }
    }
</script>
